/* Assinatura Bombom do Bem — scroll reveal (idempotente, respeita reduced-motion) */
(function () {
  if (window.__bdbReveal) { window.__bdbReveal(); return; }

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!('IntersectionObserver' in window) || reduce) {
    window.__bdbReveal = function () {
      document.querySelectorAll('.bdb-reveal:not(.bdb-obs)').forEach(function (el) {
        el.classList.add('bdb-obs', 'is-in');
      });
    };
    window.__bdbReveal();
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) {
        en.target.classList.add('is-in');
        io.unobserve(en.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

  window.__bdbReveal = function () {
    document.querySelectorAll('.bdb-reveal:not(.bdb-obs)').forEach(function (el) {
      el.classList.add('bdb-obs');
      io.observe(el);
    });
  };

  window.__bdbReveal();
  document.addEventListener('shopify:section:load', window.__bdbReveal);
})();
